// src/components/ui/SearchInput.tsx — inset search field with magnifier and clear.
import { C, F } from "../../theme";

export interface SearchInputProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
}

export const SearchInput = ({ value, onChange, placeholder }: SearchInputProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      background: C.card,
      border: `1px solid ${C.hairline}`,
      borderRadius: 14,
      padding: "10px 14px",
      boxShadow: "inset 0 1px 0 rgba(255,255,255,0.7)",
    }}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={C.inkMute}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{
        flex: 1,
        border: "none",
        outline: "none",
        background: "transparent",
        fontSize: 15,
        fontFamily: F.body,
        fontWeight: 600,
        color: C.ink,
        minWidth: 0,
      }}
    />
    {value && (
      <button
        onClick={() => onChange("")}
        type="button"
        aria-label="Clear search"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          color: C.inkMute,
          fontSize: 18,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        ×
      </button>
    )}
  </div>
);
